@if (isSpinnerActive()) {
  <div [ngClass]="className()">
    <mat-spinner [strokeWidth]="8" [diameter]="76" />
  </div>
}
